// extracted by mini-css-extract-plugin
export default {"block":"GeneralBlock_block__Ouoy0","avatarWrap":"GeneralBlock_avatarWrap__6+uyr"};